import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

interface GenerateImpersonationTokenResponse {
  success: true;
  /** Il codice monouso: vale una volta e per un minuto. Il token lo firma il server quando il gestionale lo riscatta. */
  codice: string;
  tenant_id: string;
  tenant_name: string;
  expires_in_seconds: number;
  modalita: 'azienda' | 'persona';
  persona_nome?: string;
}

const APP_USER_URL = import.meta.env.VITE_APP_USER_URL || 'https://app.yumaos.com';

/**
 * Apre il gestionale dentro un'azienda: senza `uid` in sola lettura (la modalità di sempre); con `uid` nell'account di
 * QUELLA persona, coi suoi stessi permessi (sessione assistita, 23/10/2026). Una sola funzione del server per le due.
 */
export async function startImpersonation(tenantId: string, uid?: string): Promise<void> {
  const call = httpsCallable<{ tenant_id: string; uid?: string }, GenerateImpersonationTokenResponse>(
    functions, 'generateImpersonationToken',
  );
  const result = await call({ tenant_id: tenantId, ...(uid ? { uid } : {}) });
  console.info('[impersonation] sessione aperta', { tenant: tenantId, modalita: result.data.modalita, persona: result.data.persona_nome ?? null });
  // Nel link solo il codice monouso (mai il token): `src/core/auth/sessioneDellaConsole.ts` del gestionale.
  const url = `${APP_USER_URL}/?sessione_console=${encodeURIComponent(result.data.codice)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
